<template>
  <div
    v-if="session.startup_application"
    :class="{'opacity-50 cursor-not-allowed': (inProgress ||(session.startup_application.status!='0' && session.startup_application.status!='11'))}"
  >
    <h1
      class="text-bold text-blue mb-5"
      v-if="session.session_name"
    >{{ session.session_name.label }}</h1>
    <h2
      class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b"
    >{{ $t("team.addMember") }}</h2>

    <div
      v-if="isSubmitted && errors == null"
      class="alert alert-success bg-green-light border border-green text-green px-4 py-3 rounded relative mb-4"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.submitted") }}</strong>
      </p>
    </div>
    <div
      v-if="errors.length"
      class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.infinsh") }}</strong>
      </p>
      <!-- <ul class="error-messages block sm:inline text-left p-0 list-reset">
            <li v-for="error in errors">
              <span v-if="error.message"> {{ error.message }}</span>
            </li>
      </ul>-->
    </div>

    <form autocomplete="off" name="teamAdd" v-on:submit.prevent="createTeam()">
      <div class="flex my-8 max-w-md">
        <div class="flex-1 px-4 py-2">
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="errors[0] && !team.firstname"
          >{{ $t("team.firstname") }} {{$t("form.required")}}</span>
          <sp-input
            class="mt-3"
            theme="team"
            name="firstname"
            v-model="team.firstname"
            :label="$t('team.firstname')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="errors[0] && !team.lastname"
          >{{ $t("team.lastname") }} {{$t("form.required")}}</span>
          <sp-input
            class="mt-3"
            theme="team"
            name="lastname"
            v-model="team.lastname"
            :label="$t('team.lastname')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="errors[0] && !team.role"
          >{{ $t("team.roleProject") }} {{$t("form.required")}}</span>
          <sp-input
            class="mt-3"
            theme="team"
            name="role"
            v-model="team.role"
            :label="$t('team.roleProject')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="errors[0] && !team.email"
          >{{ $t("team.email") }} {{$t("form.required")}}</span>
          <sp-input
            class="mt-3"
            theme="team"
            name="email"
            v-model="team.email"
            :label="$t('team.email')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="errors[0] && !team.phone"
          >{{ $t("team.phone") }} {{$t("form.required")}}</span>
          <sp-input
            class="mt-3"
            theme="team"
            name="phone"
            v-model="team.phone"
            :label="$t('team.phone')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="errors[0] && !team.short_bio"
          >{{ $t("team.shortBio_required") }} {{$t("form.required")}}</span>
          <sp-textarea
            class="mt-3"
            theme="team"
            v-model="team.short_bio"
            name="short_bio"
            id="short_bio"
            :label="$t('team.shortBio')"
            :required="true"
            :maxWords="300"
          ></sp-textarea>
          <!--<sp-textarea
                theme="team"
                v-model="team.brief_experience"
                name="brief_experience"
                id="brief_experience"
                :label="$t('team.briefExperience')"
          ></sp-textarea>-->
          <sp-input
            theme="team-i"
            name="linkedin_url"
            v-model="team.linkedin_url"
            :value="team.linkedin_url"
            :label="$t('team.linkedinUrl')"
            icon2="fa-linkedin-in"
          ></sp-input>

          <div class="form-control relative mb-5">
            <label class="block text-blue text-2sm font-bold mb-3">{{ $t('team.isYouTn') }}</label>
            <sp-radio
              theme="team"
              v-model="team.is_tunisian"
              v-for="(op, index) in [{name:'Oui',value:true},{name:'Non',value:false}]"
              :key="index"
              :name="'radio'+index"
              :id="'radio'+index"
              :value="op.value"
            >{{ op.name }}</sp-radio>
          </div>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="errors[0] && !team.country && !team.is_tunisian "
          >{{ $t("team.country") }} {{$t("form.required")}}</span>
          <div v-if="!team.is_tunisian" class="form-control relative mt-3">
            <sp-select-country
              v-model="team.country"
              :selected="team.country"
              theme="team"
              label="Sélectionnez votre pays de nationalité"
              placeholder="Sélectionner"
            ></sp-select-country>
          </div>
          <!--<sp-checkbox
                  theme="default"
                  name="is_tunisian"
                  id="is_tunisian"
                  :checked="team.is_tunisian"
                  @input="isTunisianUpdate"
                  >Tunisien</sp-checkbox>
              
              <sp-input
                theme="team"
                name="nationality"
                v-model="team.nationality"
                :label="$t('team.nationality')"
                :required="true"
          ></sp-input>-->
          <div class="form-control relative">
            <div
              v-if="invalidfield"
              class="border border-red-light text-sm text-red-dark px-4 py-3 mb-4 rounded relative"
              role="alert"
            >
              <ul class="error-messages block sm:inline text-left p-0 list-reset">
                <li>{{ errorMessage }}</li>
              </ul>
            </div>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="errors[0] && !team.cin_number && team.is_tunisian"
            >{{ $t("team.cinNumber") }} {{$t("form.required")}}</span>
            <sp-input
              v-if="team.is_tunisian"
              class="mt-3"
              theme="team"
              v-model="team.cin_number"
              name="cin_number"
              id="cin_number"
              :label="$t('team.cinNumber')"
              :required="true"
            ></sp-input>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="errors[0] && !team.cin_number  && team.is_tunisian == false"
            >{{ $t("team.passportNumber") }} {{$t("form.required")}}</span>
            <sp-input
              v-if="!team.is_tunisian"
              class="mt-3"
              theme="team"
              v-model="team.cin_number"
              name="cin_number"
              id="cin_number"
              :label="$t('team.passportNumber')"
              :required="true"
            ></sp-input>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="errors[0] && !team.cin_file && team.is_tunisian"
            >{{ $t("team.cin_file_required") }} {{$t("form.required")}}</span>
            <sp-dropzone
              v-if="team.is_tunisian"
              class="mt-3"
              theme="team"
              id="cin"
              :url="url"
              :label="$t('team.cinUpload')"
              :required="true"
              :vdropzonesuccess="dropzoneSuccess"
              :vdropzoneError="vdropzoneError"
              type="0"
              acceptedFiles="application/pdf"
              :vdropzone-removed-file="vdropzoneRemovedFile"
              :vdropzoneProcessing="vdropzoneProcessing"
              :maxFiles="maxFiles"
            ></sp-dropzone>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="errors[0] && !team.cin_file && team.is_tunisian == false"
            >{{ $t("team.passeport_file_required") }} {{$t("form.required")}}</span>
            <sp-dropzone
              v-if="!team.is_tunisian"
              class="mt-3"
              theme="team"
              id="cin"
              :url="url"
              :label="$t('team.cinPasseport')"
              :required="true"
              :vdropzonesuccess="dropzoneSuccess"
              :vdropzoneError="vdropzoneError"
              type="0"
              acceptedFiles="application/pdf"
              :vdropzone-removed-file="vdropzoneRemovedFile"
              :vdropzoneProcessing="vdropzoneProcessing"
              :maxFiles="maxFiles"
            ></sp-dropzone>
          </div>
        </div>
      </div>
      <div class="max-w-md">
        <div>
          <h2
            class="text-blue text-base text-bold my-5 pb-2 border-grey-light border-b"
          >{{ $t("team.cvDetails") }}</h2>

          <div class="flex justify-between mb-4">
            <div class="text-blue text-2sm font-bold">{{ $t("team.experience") }}</div>
            <div class>
              <sp-button theme="info" type="button" space="small" class @click="showExperience">
                <i class="far fa-plus-square mr-2"></i>
                {{ $t("team.addExperience") }}
              </sp-button>
            </div>
          </div>

          <div class="form mb-8" v-if="experienceAdd">
            <div
              v-if="experienceError.length"
              class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
              role="alert"
            >
              <p class="mb-0">
                <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
              </p>
              <ul class="error-messages block sm:inline text-left p-0 list-reset">
                <li v-for="error in experienceError" :key="error">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </div>

            <sp-input
              theme="team"
              name="title"
              v-model="experience.title"
              :label="$t('team.title')"
            ></sp-input>
            <sp-input
              theme="team"
              name="company"
              v-model="experience.company"
              :label="$t('team.company')"
            ></sp-input>
            <sp-input
              theme="team"
              name="location"
              v-model="experience.location"
              :label="$t('team.location')"
            ></sp-input>

            <label class="block text-blue text-2sm font-bold mb-3">{{ $t("team.selectDate") }}</label>
            <flat-picker
              v-model="experience.from_year"
              :config="{ dateFormat: 'd-m-Y' }"
              placeholder="Date de début"
              class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
            ></flat-picker>
            <flat-picker
              v-if="!experience.currently_work"
              v-model="experience.to_year"
              placeholder="Date de fin"
              :config="{ dateFormat: 'd-m-Y' }"
              class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
            ></flat-picker>
            <sp-checkbox
              theme="default"
              name="option"
              id="currently_work"
              :checked="experience.currently_work"
              @input="checkboxUpdate"
            >{{ $t("team.currentWork") }}</sp-checkbox>
            <sp-textarea
              theme="team"
              v-model="experience.description"
              name="description"
              id="description"
              label="Description"
            ></sp-textarea>

            <sp-button
              theme="outline-blue"
              space="small"
              class
              @click="addExperience"
            >{{ $t("team.save") }}</sp-button>
          </div>

          <div class="bg-grey-lighter border border-blue-lightest rounded mb-8 g-experience">
            <div
              class="card-a border-blue-lightest border-b m-4 mb-0 pb-4"
              v-for="(experience, index) in team.experience"
              :key="experience"
            >
              <div class="flex justify-between mb-4">
                <div class="text-grey-darker text-sm font-bold mb-3">
                  <h4>{{ experience.title }}</h4>
                </div>
                <div>
                  <i class="far fa-edit p-2" @click="editExperience(index)"></i>
                  <i class="fas fa-trash-alt" @click="removeExperience(index)"></i>
                </div>
              </div>
              <p class="text-grey-darker text-sm mb-2">{{ experience.company }}</p>
              <p class="text-grey-darker text-sm">
                {{ experience.from_year }} - {{ experience.to_year }}
                {{ experience.location }}
              </p>
            </div>
          </div>

          <div class="flex justify-between mb-4">
            <div class="text-blue text-2sm font-bold">{{ $t("team.educationDetails") }}</div>
            <div class>
              <sp-button theme="info" type="button" space="small" class @click="showEducation">
                <i class="far fa-plus-square mr-2"></i>
                {{ $t("team.addEducation") }}
              </sp-button>
            </div>
          </div>

          <div class="form mb-8" v-if="educationAdd">
            <div
              v-if="educationError.length"
              class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
              role="alert"
            >
              <p class="mb-0">
                <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
              </p>
              <ul class="error-messages block sm:inline text-left p-0 list-reset">
                <li v-for="error in educationError" :key="error">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </div>
            <sp-input
              theme="team"
              name="school"
              v-model="education.school"
              :label="$t('team.school')"
            ></sp-input>
            <sp-input
              theme="team"
              name="degree"
              v-model="education.degree"
              :label="$t('team.degree')"
            ></sp-input>
            <sp-input
              theme="team"
              name="field_study"
              v-model="education.field_study"
              :label="$t('team.fieldStudy')"
            ></sp-input>
            <sp-input
              theme="team"
              name="location"
              v-model="education.location"
              :label="$t('team.location')"
            ></sp-input>

            <label class="block text-blue text-2sm font-bold mb-3">{{ $t("team.selectDate") }}</label>
            <flat-picker
              v-model="education.from_year"
              :config="{ dateFormat: 'd-m-Y' }"
              placeholder="Date de début"
              class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
            ></flat-picker>
            <flat-picker
              v-model="education.to_year"
              placeholder="Date de fin"
              :config="{ dateFormat: 'd-m-Y' }"
              class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
            ></flat-picker>
            <sp-textarea
              theme="team"
              v-model="education.description"
              name="description"
              id="description"
              label="Description"
            ></sp-textarea>
            <sp-button
              theme="outline-blue"
              space="small"
              class
              @click="addEducation"
            >{{ $t("team.save") }}</sp-button>
          </div>

          <div class="bg-grey-lighter border border-blue-lightest rounded mb-8 g-education">
            <div
              class="card-a border-blue-lightest border-b m-4 mb-0 pb-4"
              v-for="(education, index) in team.education"
              :key="education"
            >
              <div class="flex justify-between mb-4">
                <div class="text-grey-darker text-sm font-bold mb-3">
                  <h4>{{ education.school }}</h4>
                </div>
                <div>
                  <i class="far fa-edit p-2" @click="editEducation(index)"></i>
                  <i class="fas fa-trash-alt" @click="removeEducation(index)"></i>
                </div>
              </div>
              <p class="text-grey-darker text-sm mb-2">{{ education.field_study }}</p>
              <p class="text-grey-darker text-sm">
                {{ education.from_year }} - {{ education.to_year }}
                {{ education.location }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex items-center justify-end w-auto bg-white shadow-box mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
      >
        <sp-button
          theme="outline-blue"
          space="small"
          :disabled="inProgress"
          class="btn btn-lg btn-primary"
          type="submit"
        >{{ $t("team.save") }}</sp-button>
      </div>
    </form>
  </div>
</template>

<style>
.g-education .card-a:last-child,
.g-experience .card-a:last-child {
  border: none;
}

.form-control--icon2 {
  top: 1.9rem;
  left: 0.05rem;
  height: 2.7rem;
}
</style>

<script>
import DropZoneVue from "../../components/spKit/DropZone.vue";
import InputVue from "../../components/spKit/Input.vue";
import TextareaVue from "../../components/spKit/Textarea.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import Link from "@/components/spKit/Link.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { ADD_TEAM } from "@/store/actions.type";
import { mapGetters } from "vuex";

import { API_URL } from "@/common/config";
import CheckboxVue from "../../components/spKit/Checkbox.vue";
const uploadURL = API_URL + "/documents/upload";
import SelectCountryVue from "../../components/spKit/selectCountry/SelectCountry.vue";
import RadioVue from "../../components/spKit/Radio.vue";
export default {
  name: "teamAdd",
  components: {
    "sp-dropzone": DropZoneVue,
    "sp-input": InputVue,
    "sp-textarea": TextareaVue,
    "sp-button": ButtonVue,
    "sp-link": Link,
    "flat-picker": flatPickr,
    "sp-checkbox": CheckboxVue,
    "sp-select-country": SelectCountryVue,
    "sp-radio": RadioVue
  },
  data() {
    return {
      url: uploadURL,
      maxFiles: 1,
      inProgress: false,
      isSubmitted: false,
      invalidfield: "",
      fileUpload: [],
      experienceAdd: false,
      educationAdd: false,
      errors: [],
      experienceError: [],
      educationError: [],
      experience: {
        title: null,
        company: null,
        location: null,
        from_year: null,
        to_year: null,
        currently_work: false,
        description: null
      },
      education: {
        school: null,
        degree: null,
        field_study: null,
        from_year: null,
        to_year: null,
        description: null
      },
      team: {
        firstname: null,
        lastname: null,
        email: null,
        short_bio: null,
        brief_experience: null,
        cin_number: null,
        cin_file: null,
        role: null,
        experience: [],
        education: [],
        is_tunisian: true,
        country: null
      }
    };
  },
  methods: {
    checkboxUpdate(check) {
      this.experience.currently_work = check;
    },
    isTunisianUpdate(check) {
      this.team.is_tunisian = check;
    },
    createTeam() {
      window.scrollTo(0, 0);
      this.$Progress.start();
      this.errors = [];
      this.inProgress = true;
      let teamForm = Object.assign({}, this.team);
      if (typeof this.fileUpload[0] != "undefined")
        teamForm.cin_file = this.fileUpload[0];
      teamForm.experience.currently_work = Number(teamForm.currently_work);
      if (!this.team.linkedin_url) delete teamForm["linkedin_url"];
      this.$store
        .dispatch(ADD_TEAM, {
          app_id: this.session.startup_application.id,
          team: teamForm
        })
        .then(() => {
          this.inProgress = false;
          this.$router.push({
            name: "teams",
            params: {
              app_id: this.session.startup_application.id
            }
          });
        })
        .catch(({ response }) => {
          this.inProgress = false;
          if (response) this.errors = response.data.meta.errors;
        });
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    showExperience() {
      this.experienceError = [];
      this.experience = {
        title: null,
        company: null,
        location: null,
        from_year: null,
        to_year: null,
        currently_work: false,
        description: null
      };
      this.experienceAdd = !this.experienceAdd;
    },
    showEducation() {
      this.educationError = [];
      this.education = {
        school: null,
        degree: null,
        field_study: null,
        from_year: null,
        to_year: null,
        description: null
      };
      this.educationAdd = !this.educationAdd;
    },
    hidexperience() {
      this.experienceError = [];
      this.experienceAdd = !this.experienceAdd;
    },
    hideEducation() {
      this.educationError = [];
      this.educationAdd = !this.educationAdd;
    },
    addExperience() {
      this.experienceError = [];
      if (!this.experience.title)
        this.experienceError.push("Titre est obligatoire");
      if (!this.experience.company)
        this.experienceError.push("Société est obligatoire");
      if (!this.experience.location)
        this.experienceError.push("Lieu est obligatoire");
      if (!this.experience.from_year)
        this.experienceError.push("Date début est obligatoire");
      if (!this.experience.to_year && !this.experience.currently_work)
        this.experienceError.push("Date fin est obligatoire");
      if (this.experienceError.length > 0) return true;
      if (this.experience.currently_work) this.experience.to_year = null;
      if (this.experience.edit !== undefined) {
        this.team.experience[this.experience.edit] = this.experience;
      } else this.team.experience.push(this.experience);
      this.showExperience();
      this.experience = {
        title: null,
        company: null,
        location: null,
        from_year: null,
        to_year: null,
        currently_work: false,
        description: null
      };
    },
    addEducation() {
      this.educationError = [];
      if (!this.education.school)
        this.educationError.push("Faculté est obligatoire");
      if (!this.education.degree)
        this.educationError.push("Diplôme est obligatoire");
      if (!this.education.field_study)
        this.educationError.push("Domaine d'étude est obligatoire");
      if (!this.education.from_year)
        this.educationError.push("Date début est obligatoire");
      if (!this.education.to_year)
        this.educationError.push("Date fin est obligatoire");
      if (this.educationError.length > 0) return true;

      if (this.education.edit !== undefined) {
        this.team.education[this.education.edit] = this.education;
      } else this.team.education.push(this.education);
      this.showEducation();
      this.education = {
        school: null,
        degree: null,
        field_study: null,
        from_year: null,
        to_year: null,
        description: null
      };
    },
    editExperience(index) {
      if (this.team.experience.hasOwnProperty(index)) {
        this.hidexperience();
        this.experience = this.team.experience[index];
        this.experience.edit = index;
      }
    },
    editEducation(index) {
      if (this.team.education.hasOwnProperty(index)) {
        this.hideEducation();
        this.education = this.team.education[index];
        this.education.edit = index;
      }
    },
    removeExperience(index) {
      if (this.team.experience.hasOwnProperty(index))
        this.team.experience.splice(index, 1);
    },
    removeEducation(index) {
      if (this.team.education.hasOwnProperty(index))
        this.team.education.splice(index, 1);
    },
    vdropzoneProcessing(file) {
      this.inProgress = true;
    },
    dropzoneSuccess(file, response) {
      this.inProgress = false;
      this.fileUpload.push(response.data.document.id);
    },
    vdropzoneError(file, message, xhr) {
      if (xhr != undefined) {
        if (message.meta.status == 400) this.fileUpload.splice(-1, 1);
      }
      this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
        "you cant upload this file";
    },
    vdropzoneRemovedFile(file, error, xhr) {
      if (xhr != undefined) {
        let data = JSON.parse(file.xhr.response);
        if (data.meta.status == 200) {
          let index = this.fileUpload.indexOf(data.data.document.id);
          if (index > -1) {
            this.fileUpload.splice(index, 1);
          }
        }
      } else {
        let index = this.fileUpload
          .map(function(x) {
            return x;
          })
          .indexOf(file.id);
        if (index > -1) {
          this.fileUpload.splice(index, 1);
        }
      }
    }
  },
  computed: {
    ...mapGetters(["session"])
  }
};
</script>

<style>
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 40%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card.container {
  padding: 2px 16px;
}
</style>
